import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Occ } from '../../../../../core/occ';
import { News } from '../model';

@Injectable({
  providedIn: 'root',
})
export class NewsConnector {
  constructor(private httpClient: HttpClient, private occEndpointsService: OccEndpointsService) {}

  loadNews(count: string): Observable<News[]> {
    const url = this.occEndpointsService.buildUrl('news', { queryParams: { count: !!count ? Number(count) : 0 } });

    return this.httpClient.get<Occ.NewsList>(url).pipe(map((newsList) => newsList.news));
  }
}
